import { useMutation } from "@tanstack/react-query";
import { FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { configuration } from "../../../configuration";

type Variables = {
  meetingGuid: string;
};

const useJoinMeetingRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function joinMeetingRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${variables.meetingGuid}/join`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "put",
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { joinMeetingRequest };
};

const useJoinMeeting = () => {
  const { joinMeetingRequest } = useJoinMeetingRequest();

  return useMutation({
    mutationFn: joinMeetingRequest,
  });
};

export { useJoinMeeting };
